// extracted by mini-css-extract-plugin
module.exports = {"singleNumber":"SingleNumber_singleNumber__3uc6J","number":"SingleNumber_number__2SaDD","title":"SingleNumber_title__6Fotm"};